import { apiResourceUrl } from "@ploy-lib/core";
import { BaseCamelCasedResource } from "./BaseResource";

export interface BankIntentionResourceType {
	readonly applicationId?: number;
	readonly supplierId?: number;
	readonly bankIntention: string;
	readonly message: string;
}

export class BankIntentionResource
	extends BaseCamelCasedResource
	implements BankIntentionResourceType
{
	readonly applicationId?: number = 0;
	readonly supplierId?: number = 0;
	readonly bankIntention: string;
	readonly message: string;

	pk() {
		return this.applicationId?.toString() || "";
	}

	static urlRoot = apiResourceUrl("bank-intention");
}

export class SendBankIntentionResource extends BankIntentionResource {
	static urlRoot = apiResourceUrl("bank-intention/send");
}
